import React, { useState } from "react";
import "../../../Styles/Redirecting Styles/WebDevelopment.css";
import { faPhone, faPlay } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/Service.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../Styles/Redirecting Styles/NavbarStyles/Business.css";
import Shape2 from "../../../assets/brand/choose-shape-2.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";
import section1 from "../../../assets/canada/Business-Automation/Bus-Aut-Sec-1-1.jpg";
import section2 from "../../../assets/canada/Business-Automation/Bus-Aut-Sec-1-2.jpg";
import section3 from "../../../assets/canada/Business-Automation/Bus-Aut-Sec-1-3.jpg";
import section4 from "../../../assets/canada/Business-Automation/Bus-Audit-Sec-2.jpg";


const CanadaWebDevelopment = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
          Get the Best Business Automation Software Solutions in Canada
        </title>
        <meta
          name="description"
          content="Transform your operations with the best business automation software services in Canada. Streamline processes with our expert business automation."
        />
        <meta
          name="keywords"
          content="business automation canada, business automation software canada, business automation software, automation software canada, business automation services canada"
        />
      </Helmet>

      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg2 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
                  Business Automation
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Business automation involves the fusion of technology and
                      strategic planning to elevate the efficiency of business
                      operations.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}
      <section className="bd-choose-area fix pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-text z-index">
                  <div className="bd-section-title-wrapper ">
                    <h2 className="bd-section-title mb-15 first_section-title">
                      The Service That's Perfect for You
                    </h2>
                  </div>

                  <p
                    className="mb-20 first_section_para1"
                    style={{ fontSize: "18px" }}
                  >
                    At its core, business automation entails the harmonious
                    blend of technology and strategic business prowess, all with
                    the goal of refining business operations. Whether you're
                    leveraging office automation tools like Outlook or Google
                    Sheets, or venturing into product automation platforms such
                    as Salesforce or Jetpack, the impact of business automation
                    is profound, amplifying workflow efficiency. It's an
                    indispensable component of any business, offering a diverse
                    array of business automation systems to suit your needs.
                    Right here at Zithas, we've meticulously curated a
                    comprehensive selection of the market's finest business
                    automation systems, ready to guide you on your personalized
                    business automation expedition.
                  </p>
                  <p
                    className="mb-20 first_section_para1"
                    style={{ width: "95%", fontSize: "18px" }}
                  >
                    {" "}
                    Businesses of all scales find value in business automation
                    to simplify their operations. Whether you're a newly
                    established venture or looking to take your business to new
                    heights, business automation is an indispensable service
                    that automates everyday tasks within your organization. It
                    serves as a superb means to enhance operational efficiency
                    and amplify profitability.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end top-resp z-index">
                  <div className="row align-items-center  custom-mar-15">
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                        <img
                          src={section1}
                          className="resp-img bordertop-img1"
                          alt="img not found"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={section2}
                          className="resp-img bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659372146/website/business-automation/business-automation-sec-1.3_o5bd0e.jpg"
                          className="resp-img bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  />
                  {/* <div className="bd-choose-video-popup">
                                    <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <ModalVideo
                    autoplay
                    isOpen={isOpen}
                    channel="youtube"
                    videoId="2LRxhuDssLQ"
                    onClose={() => setOpen(false)}
                ></ModalVideo>
                <button
                    className="btn btn responsive_digital first_pop_video_business"
                    onClick={() => setOpen(true)}
                >
                    <FontAwesomeIcon
                        icon={faPlay}
                        className="play_bt_vid play_transition"
                    />
                </button> */}
      </section>

      {/* Second Section */}
      <section className="bd-about-area-two ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div
            className="row justify-content-center "
            style={{ alignItems: "center" }}
          >
            <div className="col-xl-6 col-lg-8 second_section_Business1">
              <div className="bd-about-img-two">
                <img
                  src={section4}
                  className="pl-110"
                  alt="img not found"
                  style={{ width: "93%" }}
                />
                {/* <div className="bd-about-img-two-expe">
                                <img src={aboutShape6} alt="img not found"/>
                                <div className="bd-about-img-two-expe-text">
                                    <h4>5+</h4>
                                    <span>Experience</span>
                                </div>
                            </div> */}
              </div>
            </div>
            <div className="col-xl-6 col-lg-8 second_section_Business2">
              <div className="bd-about-text-two">
                <div className="bd-section-title-wrapper mb-25">
                  <h2 className="bd-section-title mb-15 second_sec_tittle">
                    Incorporating{" "}
                    <span style={{ color: "#ffbf1e" }}>
                      Business Automation:{" "}
                    </span>{" "}
                    The Key Trend for Innovators.
                  </h2>
                  <p>
                    Business leaders in Canada stand to gain significantly from
                    the array of benefits offered by business automation
                    services, most notably heightened efficiency and precision.
                    These services play a pivotal role in trimming down task
                    completion timelines, elevating accuracy and uniformity in
                    business processes, and curtailing operational expenditures.
                    What's more, business automation services pave the way for
                    enhanced communication and collaboration among business
                    owners and their workforce. Leveraging automation software,
                    businesses can automate an array of tasks and processes,
                    expediting workflow and magnifying efficiency. This results
                    in substantial savings in both time and money, all while
                    enhancing the overall organizational structure and
                    effectiveness.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}
      <section className="bd-service-area pt-80 ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-12">
              <div className="bd-section-title-wrapper text-center mb-25">
                <h2
                  className="bd-section-title mb-10 third_sec_tittle"
                  style={{ textAlign: "left" }}
                >
                  Empowering Business Productivity through
                  <span style={{ color: "#ffbf1e" }}>
                    {" "}
                    Business Automation
                  </span>{" "}
                </h2>
              </div>
            </div>
          </div>
          <h2 className="pb-2">Types of Automation :</h2>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <h4 className="bd-service-title mb-20">
                  <a>1. Task Automation</a>
                </h4>
                <p>
                  Task automation involves the use of technology to streamline
                  and perform repetitive tasks, allowing for increased
                  efficiency and accuracy in various processes, ultimately
                  saving time and resources.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <h4 className="bd-service-title mb-20">
                  <a>2. Workflow Automation</a>
                </h4>
                <p>
                  It refers to the implementation of technology to automate and
                  optimize the sequence of tasks within an organization,
                  ensuring smoother operations, reduced errors, and enhanced
                  productivity.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <h4 className="bd-service-title mb-20">
                  <a>3. Process Automation</a>
                </h4>
                <p>
                  Process automation is the use of technology to streamline and
                  optimize business procedures, reducing manual effort and
                  improving overall efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section */}
      <section className="bd-brand-area-two pb-80 pt-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row fourt_respon_business">
            <div className="col-xl-4 col-lg-6 col-md-6 first_part_respons">
              <div className="col-12">
                <div className="bd-section-title-wrapper mb-20">
                  <h2 className="bd-section-title mb-25 mt-0 pl-0 fourth_sec_tittle">
                    The Roadblocks Faced When Adopting
                    <span style={{ color: "#ffbf1e" }}>
                      {" "}
                      Business Automation
                    </span>{" "}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-6 col-md-6 second_part_respons">
              <div className="bd-brand-active-two swiper-container">
                <div className="swiper-wrapper">
                  <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                    As businesses embrace business automation, they invariably
                    face a range of challenges. These encompass repetitive
                    tasks, the demand for quick task completion, issues related
                    to task management and prioritization, potential errors in
                    task sequencing, and the intricacy of issue detection.
                    Uncertainty surrounding requirements and implementation best
                    practices is a prevalent challenge. Additionally, resource
                    limitations can pose obstacles to effective business
                    automation. The process also introduces hurdles such as
                    maximizing technology utilization, adeptly managing and
                    supervising automation initiatives, and ensuring a seamless
                    transition for employee accustomed to manual processes. To
                    surmount these challenges, businesses can employ a variety
                    of strategies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fiveth Section */}
      <section className="bd-about-six-area ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div
            className="row fifth_section_responsive"
            style={{ alignItems: "center" }}
          >
            <div className="col-lg-6 Business_fifth_flex1">
              <div className="bd-about-six-text">
                <div className="bd-section-title-wrapper mb-25">
                  <h2 className="bd-section-title mb-25 sixth_sec_tittle">
                    Explore Tailored <br />{" "}
                    <span style={{ color: "#ffbf1e" }}>
                      Business Automation{" "}
                    </span>{" "}
                    Services for Your Organization
                  </h2>
                  <div className="bd-about-six-feature">
                    <p className="" style={{ width: "95%" }}>
                      Discover the transformative potential of tailored business
                      automation services with Zithas Technologies. Our
                      expertise lies in crafting solutions uniquely suited to
                      your organization's needs. That's why we offer customized
                      automation solutions designed to meet your unique needs.
                      Whether it's automating repetitive tasks, optimizing
                      complex workflows, or enhancing your overall operational
                      efficiency, our team of experts is committed to delivering
                      innovative automation solutions that align with your
                      goals.
                    </p>

                    <p style={{ width: "95%" }}>
                      Our proven track record in Canada's tech industry
                      demonstrates our ability to empower businesses of all
                      sizes with cutting-edge automation tools. By partnering
                      with us, you'll unlock opportunities to reduce costs,
                      minimize errors, and free up valuable human resources.
                      Embrace the future of business automation with us and
                      experience a seamless transition towards increased
                      profitability and competitiveness.
                    </p>

                    {/* <p style={{ width: "95%" }}>
                      With our business automation services, we can assist you
                      in enhancing the development and management of your
                      business processes, ensuring smooth and efficient
                      operations. Partner with us to unlock the full potential
                      of your business!
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-8 Business_fifth_flex2">
              <div className="bd-about-six-img">
                <div className="bd-about-six-feature">
                  <div className="bd-slider-six-img">
                    <img
                      src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659412581/website/business-automation/business-automation-sec-3_icf3jr.jpg"
                      className="rounded-10"
                      alt="img not found"
                      style={{ width: "100%" }}
                    />
                    <img
                      src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659587681/website/business-audit/slider-shape-3_rtsny4.png"
                      className="bd-slider-six-img-shape1"
                      alt="img not found"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sixth Section */}
      <section className="bd-choose-area fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape pt-80 pb-80 ">
            <div className="row Business_resp_section">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 sixth_sec1_resp">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-img z-index">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col business-resp mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440127/website/icons/productive-64_slmdbc.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Greater Productivity
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440127/website/icons/customer-64_do2spq.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Better Customer Service
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container text-center">
                      <div className="row ">
                        <div className="col mr-30">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img
                                  src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440127/website/icons/tracking-32_foagg2.png"
                                  style={{ width: "62px" }}
                                />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Full Audibility and Tracking
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440127/website/icons/aim-64_o0wi5u.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Increased Efficiency & Improved Accuracy
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 sixth_sec2_resp">
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title business-last-tittle">
                    Our Role in System Development Process
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      In Canada, our company is dedicated to empowering
                      businesses with enhanced efficiency and effectiveness. We
                      provide a wide array of comprehensive business automation
                      services geared toward optimizing technology utilization
                      within your organization. Our portfolio encompasses
                      cutting-edge tools and services designed to streamline
                      your business operations. We are committed to delivering
                      convenient and cost-effective business automation
                      solutions, enabling businesses to work smarter.
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}

      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for Business Automation Expert in Canada?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding Automation Services, Let's Kickstart Now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (647) 446-9073"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (647) 446-9073
                  </a>
                </div>
              </div>
              {/* <Link to={"/contact-us"} onClick={toggleContact}>
                    <button className="touch-btn1 mt-20">Get Started</button>
                    </Link> */}
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
      {/* </div> */}
    </div>
  );
};

export default CanadaWebDevelopment;
